import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { PickerType } from 'src/app/models_new/enums/picker-type';
import { ThreeViewComponent } from '../three-view/three-view.component';
import * as PPBTimeUtil from 'src/app/utils/time-utils';
import { OrganizationLogoService } from 'src/app/services/organization-logo.service';
import { ExportImportService } from 'src/app/services/export-import.service';
import { Project } from 'src/app/models_new/classes/project';
import { getLastEdited } from 'src/app/utils/time-utils';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ITableData } from '../table/table.component';

const EXPAND_COLLAPSE_DURATION = 200;
@Component({
  selector: 'app-card-pattern-view',
  templateUrl: './card-pattern-view.component.html',
  styleUrls: ['./card-pattern-view.component.scss'],
  animations: [
    trigger('expandDetails', [
      state(
        'false',
        style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1 })
      ),
      state('true', style({ height: '0', visibility: 'hidden', opacity: 0 })),
      transition(
        'false => true',
        animate(EXPAND_COLLAPSE_DURATION + 'ms ease-in')
      ),
      transition(
        'true => false',
        animate(EXPAND_COLLAPSE_DURATION + 'ms ease-out')
      ),
    ]),
  ],
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class CardPatternViewComponent<ActionType> implements OnInit, OnChanges {
  @ViewChild(ThreeViewComponent) threeView: ThreeViewComponent;

  @Input() type: PickerType;
  @Input() data: any;
  @Input() doesAllowActions: boolean;
  @Input() cardDetailsData: any;
  @Input() columnColors: string[];
  @Input() listColumnUnits: string[];
  @Input() selectedCards: any[];

  @Output() cardClicked: EventEmitter<ITableData['data']> = new EventEmitter();

  fullDetailList: any;
  isSelected: boolean;
  detailsCollapsed: boolean = true;
  timeUtils = PPBTimeUtil;
  last_edited: string = undefined;
  project: Project;
  interactive: boolean = false;

  constructor(
    private exportImport: ExportImportService,
    public logoService: OrganizationLogoService
  ) {}

  ngOnInit() {
    this.isSelected = this.selectedCards.find(
      (e) => e.id === this.data.pattern.id
    )
      ? true
      : false;

    this.project = this?.data
      ? this.exportImport.mapToProjectFormat(this.data.pattern.data)
      : null;

    this.fullDetailList = this.appendProjectData(this.data, this.project);

    this.last_edited = this.data?.updated_at
      ? getLastEdited(this.data.updated_at)
      : null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedCards.currentValue) {
      this.isSelected = changes.selectedCards.currentValue.find(
        (e) => e.id === this.data.pattern.id
      )
        ? true
        : false;
    }
  }

  appendProjectData(data: any, project: Project) {
    const fieldsToAdd = {};

    fieldsToAdd['pallet_weight'] =
      project?.getActivePallet().palletSummary?.palletWeight / 1000 + ' kg';
    fieldsToAdd['number_of_layers'] =
      project?.getActivePallet().palletSummary?.numberOfLayers;
    fieldsToAdd['box_count'] =
      project?.getActivePallet().palletSummary?.boxCount;

    return { ...data, ...fieldsToAdd };
  }

  onDetailsExpandClick() {
    this.detailsCollapsed = !this.detailsCollapsed;
  }

  cardClick(element: ITableData['data']) {
    this.cardClicked.emit(element);
  }
}
